import { useRef } from 'react'
import { useTenantImport, type TenantImportWorkflowInvoker } from './useTenantImport'
import { downloadTenantImport } from './download'
import type { TenantImportLanguage } from './copy'

export function useTenantImportDownload({
    language = 'de',
    invokeWorkflow,
}: {
    language?: TenantImportLanguage
    invokeWorkflow: TenantImportWorkflowInvoker
}) {
    const filename = useRef('Mieterliste')
    return useTenantImport({
        language,
        target: {
            completion: 'download',
            loadContext: async (file) => {
                filename.current = file.name
                return {
                    target: 'excel_export',
                    valuation_date: null,
                    property_description: '',
                    structures: [],
                }
            },
            complete: (rows) => downloadTenantImport(rows, filename.current),
        },
        invokeWorkflow,
    })
}
